gz-info-box {
  padding: calc(var(--spacer) * 2) 0;
}

gz-dropdown {
  --form-field-input-width: 400px;
}

gz-title + gz-form-field, gz-title + gz-labeled-content {
  padding-top: 15px;
}

.helper-text {
  padding-top: calc(var(--spacer) * 0.5);
}

gz-complex-enum-list {
  border: 1px solid var(--chart-100-pressed);
  border-radius: 5px;
  width: 649px;
}

#action-field {
  position: relative;
  z-index: 0;
}

gz-policy-panel-application-control-targets-table {
  margin-top: -35px;
}

gz-checkbox {
  width: auto;
}

gz-radio {
  width: fit-content;
}
